// removed by extract-text-webpack-plugin
module.exports = {"text800":"_3EW97Yxl9-q_bc7QIgfY1T","text700":"_2S3z4UXBtS_cPxOvS0NN_E","text600":"_39Qs4v7AohJC1G3gCbo7rn","text500":"Cgp-g-KzUv9KkIBBdxeAt","text400":"_2DRGh9xfIkBD0WTTDca1nK","text300":"_2TwS_pHxHu4EQ-O-HX_HMu","text200":"_9P3A20S8xghqWTWXvpFa8","textParagraph":"_21h-iOnvAmHFFlz93FfX6k","crimp":"d5COadv8j7OBEHBMefhe6","trim":"BCYz0JfaQZNtW4wxWQqli","flexCenter":"_2dkSd00WLApp1AWmn0fApu","card":"_3MP7ekG3fB-_WWW8r_9fLz","brand":"_4V6drXbTjlb7Ovoak1aPv","hideTextOverflow":"Bp-BdpOjp0DtSVIPbxVxR","marginPageMainContent":"_1cZxRKPxYQO6PSeZNaucAO","wrapper":"_1cJqqbnhfYOVUqqFRmDEQQ"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/PageAuthentication/styles.scss
// module id = 725
// module chunks = 0